import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectInfo } from 'projects/money-movement-ui/src/app/account-info-header/reducers';
import { selectIraFieldsIsIraTransaction } from 'projects/money-movement-ui/src/app/create-request/reducers';
import { transactionTypes } from 'projects/money-movement-ui/src/app/shared/utilities/Constants';
import { Subject, takeUntil } from 'rxjs';

@Component({
  standalone: false,
  selector: 'mm-transaction-review-it',
  templateUrl: './transaction-review-it.component.html',
  styleUrl: './transaction-review-it.component.scss'
})
export class TransactionReviewItComponent implements OnInit {

  readonly subtitle: string = 'From account details';
  readonly it: string = transactionTypes.internalTransfer;
  isIra: boolean;
  isPtrs: boolean;
  destroy$: Subject<void> = new Subject<void>();


  constructor(private store: Store){
  }

  ngOnInit(): void {
     this.store.select(selectIraFieldsIsIraTransaction).pipe(takeUntil(this.destroy$)).subscribe(_isIraTransaction => this.isIra = _isIraTransaction)
      this.store.select(selectInfo).pipe(takeUntil(this.destroy$)).subscribe(info => {
        this.isPtrs = info.classifications.isPtrs;
      });
  }

}
